import { Navigate } from 'react-router';
import { Stack } from '../../design-system/stack/stack';
import Header from '../layout/header';
import { ConnectedOAuthProviderWrapper } from './components/connected-oauth-provider-wrapper';
import { OAuthConnectionTable } from './components/oauth-connection-table';
import { OAuthConnectionsTableWrapper } from './components/oauth-connections-table-wrapper';
import { AllowedOAuthProvider, OAuthConnectionInformation, OAuthProviderConnection } from './types/types';

const ACTIVE_CONNECTION_STATUS = 'CONNECTED';

type ProviderConfig =
  | { provider: undefined }
  | {
      provider: AllowedOAuthProvider;
      connectionStatus: OAuthConnectionInformation;
      onGoBack: () => void;
      onDisconnect: () => void;
    };

type IntegrationsPageProps = {
  connections: OAuthProviderConnection[];
  providerConfig: ProviderConfig;
  onReviewInvoice: (connectionId: string) => void;
};

export const IntegrationsPage = ({ connections, providerConfig, onReviewInvoice }: IntegrationsPageProps) => {
  const activeConnections = connections.filter((c) => c.status === ACTIVE_CONNECTION_STATUS);
  const availableConnections = connections.filter((c) => c.status !== ACTIVE_CONNECTION_STATUS);

  if (providerConfig.provider && !providerConfig.connectionStatus?.connected) {
    return <Navigate to="/dashboard/integrations" replace />;
  }

  return (
    <Stack align="stretch" className="min-h-screen p-2.5">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-lg bg-white">
        <div className="overflow-clip">
          <Header />
        </div>

        {providerConfig.provider && <ConnectedOAuthProviderWrapper {...providerConfig} />}

        {!providerConfig.provider && (
          <Stack space={10} align="stretch" className="px-32">
            <h1 className="text-2xl font-semibold leading-5 tracking-tight text-black">Integrations</h1>

            {activeConnections.length > 0 && (
              <Stack space={10} align="stretch">
                <OAuthConnectionsTableWrapper title="Active Connections">
                  <OAuthConnectionTable connections={activeConnections} onReviewInvoice={onReviewInvoice} />
                </OAuthConnectionsTableWrapper>
              </Stack>
            )}

            {availableConnections.length > 0 && (
              <Stack space={10} align="stretch">
                <OAuthConnectionsTableWrapper title="Available Connections">
                  <OAuthConnectionTable connections={availableConnections} onReviewInvoice={onReviewInvoice} />
                </OAuthConnectionsTableWrapper>
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
